/**
 * en-GB messages added by Phase 3 task S28B (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s28bEnGB = {
    'compliance.induction.error.too_many_attempts': 'Too many attempts at this induction. Please wait an hour and try again, or ask reception.',
    'compliance.induction.error.upload': 'That video or PDF could not be used. Upload it again.',
    'compliance.induction.error.quiz': 'Each question needs 2 to 6 different options and the right number of correct answers.',
    'compliance.induction.error.version': 'This induction was changed while you were taking it. Please start it again.',
    'compliance.induction.error.too_large': 'That file is larger than the induction size limit.',
    'compliance.induction.invalid': 'The induction result could not be read, so it was not recorded.',
    'compliance.induction.regraded': 'The induction result was marked again by the server and differs from the kiosk.',
    'compliance.induction.not_passed': 'The induction was not passed.',
    'compliance.induction.col.name': 'Name',
    'compliance.induction.col.group': 'Group',
    'compliance.induction.col.induction': 'Induction',
    'compliance.induction.col.version': 'Version',
    'compliance.induction.col.passed': 'Passed',
    'compliance.induction.col.expires': 'Expires',
    'compliance.induction.col.via': 'Where',
    'compliance.induction.col.score': 'Score (%)',
    'compliance.induction.via.kiosk': 'Kiosk',
    'compliance.induction.via.companion': 'App',
    'compliance.induction.via.prearrival': 'Pre-arrival page',
    'compliance.induction.via.contactless': 'Visitor phone',
    'compliance.induction.via.portal': 'Portal',
    'compliance.induction.sheet': 'Inductions',
};
//# sourceMappingURL=s28b.js.map